export const VuesticTheme = {
  Primary: 'Primary',
  Danger: 'Danger',
  Info: 'Info',
  Success: 'Success',
  Warning: 'Warning',
  White: 'White',
  Black: 'Black',
}

export const colorConfig = {
  [VuesticTheme.Primary]: '#4ae387',
  [VuesticTheme.Danger]: '#e34a4a',
  [VuesticTheme.Info]: '#4ab2e3',
  [VuesticTheme.Success]: '#db76df',
  [VuesticTheme.Warning]: '#f7cc36',
  [VuesticTheme.White]: '#fff',
  [VuesticTheme.Black]: '#000',
}

export const allColorsArray =
[
  '#696969',
  '#2e8b57',
  '#7f0000',
  '#808000',
  '#000080',
  '#ff4500',
  '#ffa500',
  '#c71585',
  '#7cfc00',
  // '#00fa9a',
  '#00ffff',
  '#ffd700',
  // '#00bfff',
  '#9370db',
  '#0000ff',
  '#ff00ff',
  '#eee8aa',
  '#ffff54',
  '#ffb6c1'
]

export const colorArray = Object.values(colorConfig)
